import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import React from 'react';
import JournalCategory from '../../../../components/templates/journal/journalCategory';
import JournalCategorySchema from '../../../../components/molecules/journal/seo/category/JournalCategorySchema';

const JournalHomeTastic = ({ data, tastic, context, isServerSideRendering }) => {
  const isSSR = (typeof isServerSideRendering === 'boolean') && isServerSideRendering;
  const content = data?.blogHomeData;
  const categories = content?.topCategories ?? [];
  const articlesCollection = content?.articlesCollection ?? {};
  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';

  if (!data[`show${locale}`]) return null;

  const title = data?.title ?? '';
  const description = data?.description ?? '';
  const metaData = {
    title: data?.metaTitle || title,
    description: data?.metaDescription || description,
    keywords: data?.metaKeywords || '',
  };

  const banner = {
    subtitle: data?.bannerSubtitle,
    title: data?.bannerTitle,
    description: data?.bannerDescription,
    hasScrollBottomButton: data?.hasScrollBottomButton,
    fullWidth: data?.fullWidth,
    media: {
      desktop: {
        url: data.bannerMediaDesktop?.media?.file,
        title: data.bannerMediaDesktop?.media?.name,
        type: data.bannerMediaDesktop?.media?.resourceType,
        aspectRatio: data.bannerMediaDesktop?.ratio,
      },
      tablet: {
        url: data.bannerMediaTablet?.media?.file,
        title: data.bannerMediaTablet?.media?.name,
        type: data.bannerMediaTablet?.media?.resourceType,
        aspectRatio: data.bannerMediaTablet?.ratio,
      },
      mobile: {
        url: data.bannerMediaMobile?.media?.file,
        title: data.bannerMediaMobile?.media?.name,
        type: data.bannerMediaMobile?.media?.resourceType,
        aspectRatio: data.bannerMediaMobile?.ratio,
      },
    },
  };

  const teaser = {
    url: data.teaserUrl,
    position: data.teaserPosition,
    media: {
      desktop: {
        url: data.teaserMediaDesktop?.media?.file,
        title: data.teaserMediaDesktop?.media?.name,
        type: data.teaserMediaDesktop?.media?.resourceType,
        aspectRatio: data.teaserMediaDesktop?.ratio,
      },
      tablet: {
        url: data.teaserMediaTablet?.media?.file,
        title: data.teaserMediaTablet?.media?.name,
        type: data.teaserMediaTablet?.media?.resourceType,
        aspectRatio: data.teaserMediaTablet?.ratio,
      },
      mobile: {
        url: data.teaserMediaMobile?.media?.file,
        title: data.teaserMediaMobile?.media?.name,
        type: data.teaserMediaMobile?.media?.resourceType,
        aspectRatio: data.teaserMediaMobile?.ratio,
      },
    },
  };

  return (
    <>
      <JournalCategory
        isSSR={isSSR}
        categories={categories}
        title={title}
        banner={banner}
        teaser={teaser}
        pageTitle={title}
        articles={articlesCollection?.items}
        description={description}
        backgroundColor={data?.backgroundColor}
        paginationState={{
          limit: articlesCollection?.limit,
          skip: articlesCollection?.skip,
          total: articlesCollection?.total,
        }}
        hideBreadcrumbs
      />
      <JournalCategorySchema
        title={metaData?.title}
        description={metaData?.description}
        keywords={metaData?.keywords}
        url={null}
        image={articlesCollection?.items?.[0]?.thumbnail?.desktop?.url}
        articles={articlesCollection?.items}
        placement="BlogHome"
      />
    </>
  );
};

export default tastify({
  translate: true,
  connect: {
    tastic: true,
    isServerSideRendering: true,
    context: true,
  },
})(JournalHomeTastic);
